var HyperLinkSupport         = require("enyo-ui/HyperLinkSupport"),
    IconButton               = require("app/ui/IconButton"),
    Scroller                 = require("enyo-ui/Scroller"),
    ScrollerMouseDragSupport = require("app/ui/ScrollerMouseDragSupport"),
    buttons                  = require("app/theme/buttons"),
    config                   = require("app/config"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    kind                     = require("enyo/kind"),
    onHyperlinkTap           = require("app/utils/onHyperlinkTap"),
    quickMacroize            = require("enyo/macroize").quickMacroize;

require("./TabBar.less");

module.exports = kind(/** @lends app.HomePage.TabBar.prototype */ {

    /**
     * @private
     */
    name: "app.HomePage.TabBar",

    /**
     * @private
     */
    classes: "app-home-page-tab-bar",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        classes:        "app-home-page-tab-bar__scroller",
        kind:           Scroller,
        mixins:         [ScrollerMouseDragSupport],
        vertical:       false,
        horizontal:     true,
        scrollChaining: false,
        maxWidth:       "100%",
        components:     [{
            name:       "tabs",
            classes:    "app-home-page-tab-bar__tabs",
            components: [{
                name:    "contentTab",
                kind:    IconButton,
                classes: "app-home-page-tab-bar__tab active",
                theme:   buttons["app.HomePage.TabBar.tab"]
            }, {
                name:    "shortsTab",
                kind:    IconButton,
                classes: "app-home-page-tab-bar__tab",
                mixins:  [HyperLinkSupport],
                theme:   buttons["app.HomePage.TabBar.tab"],
                ontap:   "onHyperlinkTap"
            }, {
                name:       "agendaTab",
                kind:       IconButton,
                mixins:     [HyperLinkSupport],
                classes:    "app-home-page-tab-bar__tab",
                theme:      buttons["app.HomePage.TabBar.tab"],
                components: [{
                    name:        "agendaTabComingSoon",
                    classes:     "app-home-page-tab-bar__tab__coming-soon",
                    canGenerate: !get(config, "pageUrls.agendaPageUrl", false)
                }, {
                    name:        "agendaTabNew",
                    classes:     "app-home-page-tab-bar__tab__new",
                    canGenerate: Boolean(get(config, "pageUrls.agendaPageUrl", false))
                }],
                ontap: "onHyperlinkTap"
            }, {
                name:       "newsTab",
                kind:       IconButton,
                classes:    "app-home-page-tab-bar__tab disabled",
                theme:      buttons["app.HomePage.TabBar.tab"],
                components: [{
                    name:    "newsTabComingSoon",
                    classes: "app-home-page-tab-bar__tab__coming-soon"
                }]
            }, {
                name:       "liveTab",
                kind:       IconButton,
                classes:    "app-home-page-tab-bar__tab disabled",
                theme:      buttons["app.HomePage.TabBar.tab"],
                components: [{
                    name:    "liveTabComingSoon",
                    classes: "app-home-page-tab-bar__tab__coming-soon"
                }]
            }, {
                name:       "shopTab",
                kind:       IconButton,
                classes:    "app-home-page-tab-bar__tab disabled",
                theme:      buttons["app.HomePage.TabBar.tab"],
                components: [{
                    name:    "shopTabComingSoon",
                    classes: "app-home-page-tab-bar__tab__coming-soon"
                }]
            }]
        }]
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $i18nService  = this.app.$.i18nService,
            shortsPageUrl = get(config, "pageUrls.shortsPageUrl", null),
            agendaPageUrl = get(config, "pageUrls.agendaPageUrl", null),
            $contentTab   = this.$.contentTab,
            $shortsTab    = this.$.shortsTab,
            $newsTab      = this.$.newsTab,
            $liveTab      = this.$.liveTab,
            $agendaTab    = this.$.agendaTab,
            $shopTab      = this.$.shopTab;

        $contentTab.set("caption", $i18nService.getString("app.HomePage.TabBar.contentTab.caption"));
        $contentTab.set("tooltip", $i18nService.getString("app.HomePage.TabBar.contentTab.tooltip"));

        $shortsTab.set("caption", $i18nService.getString("app.HomePage.TabBar.shortsTab.caption"));
        $shortsTab.set("tooltip", $i18nService.getString("app.HomePage.TabBar.shortsTab.tooltip"));
        $shortsTab.set("href", shortsPageUrl ? quickMacroize(shortsPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        $agendaTab.set("caption", $i18nService.getString("app.HomePage.TabBar.agendaTab.caption"));
        $agendaTab.set("tooltip", $i18nService.getString("app.HomePage.TabBar.agendaTab.tooltip"));
        $agendaTab.set("href", agendaPageUrl ? quickMacroize(agendaPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        $newsTab.set("caption", $i18nService.getString("app.HomePage.TabBar.newsTab.caption"));
        $newsTab.set("tooltip", $i18nService.getString("app.HomePage.TabBar.newsTab.tooltip"));

        $liveTab.set("caption", $i18nService.getString("app.HomePage.TabBar.liveTab.caption"));
        $liveTab.set("tooltip", $i18nService.getString("app.HomePage.TabBar.liveTab.tooltip"));

        $shopTab.set("caption", $i18nService.getString("app.HomePage.TabBar.shopTab.caption"));
        $shopTab.set("tooltip", $i18nService.getString("app.HomePage.TabBar.shopTab.tooltip"));


        this.$.agendaTabComingSoon.set("content", agendaPageUrl ? $i18nService.getString("app.HomePage.TabBar.Tab.comingSoon") : null);
        this.$.agendaTabNew.set("content", agendaPageUrl ? $i18nService.getString("app.HomePage.TabBar.Tab.new") : null);
        this.$.newsTabComingSoon.set("content", $i18nService.getString("app.HomePage.TabBar.Tab.comingSoon"));
        this.$.liveTabComingSoon.set("content", $i18nService.getString("app.HomePage.TabBar.Tab.comingSoon"));
        this.$.shopTabComingSoon.set("content", $i18nService.getString("app.HomePage.TabBar.Tab.comingSoon"));
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @param   {enyo.Control}  sender  The sender
     * @return  {boolean}       Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
